import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';

const POI_ICONS = {
  ecole: { icon: '🎓', color: '#3B82F6' },
  mosquee: { icon: '🕌', color: '#1D9E75' },
  transport: { icon: '🚇', color: '#8B5CF6' },
  commerce: { icon: '🛒', color: '#F59E0B' },
  sante: { icon: '🏥', color: '#EF4444' },
  parc: { icon: '🌳', color: '#10B981' }
};

const SCORE_KEYS = [
  { key: 'transport_score', scoreKey: 'transport', icon: '🚇', color: '#8B5CF6' },
  { key: 'securite_score', scoreKey: 'securite', icon: '🛡️', color: '#1D9E75' },
  { key: 'education_score', scoreKey: 'education', icon: '🎓', color: '#3B82F6' },
  { key: 'commerces_score', scoreKey: 'commerces', icon: '🛒', color: '#F59E0B' }
];

function QuartierPanel({ detail, formatPrix, onClose }) {
  const { t } = useI18n();
  const { quartier, pois, stats } = detail;

  return (
    <div className="quartier-panel">
      {/* Header */}
      <div className="panel-header">
        <div className="panel-header-top">
          <div>
            <h2>{quartier.nom}</h2>
            <div className="nom-ar">{quartier.nom_ar}</div>
          </div>
          <button className="panel-close" onClick={onClose}>&times;</button>
        </div>
        <span className="panel-ambiance">{quartier.ambiance}</span>
      </div>

      <div className="panel-body">
        {/* Description */}
        <p className="panel-description">{quartier.description}</p>

        {/* Scores */}
        <div className="panel-section-title">{t.carte.scoresTitle}</div>
        <div className="scores-grid">
          {SCORE_KEYS.map(s => {
            const val = quartier[s.key] || 0;
            return (
              <div className="score-row" key={s.key}>
                <span className="score-icon">{s.icon}</span>
                <span className="score-label">{t.carte.score[s.scoreKey]}</span>
                <div className="score-bar-bg">
                  <div
                    className="score-bar-fill"
                    style={{
                      width: `${val * 20}%`,
                      background: s.color
                    }}
                  />
                </div>
                <span className="score-value">{val}/5</span>
              </div>
            );
          })}
        </div>

        {/* Stats prix */}
        {stats.nbAnnonces > 0 && (
          <>
            <div className="panel-section-title">{t.carte.marketTitle}</div>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-value">{stats.nbAnnonces}</div>
                <div className="stat-label">{t.carte.listings}</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">
                  {stats.prixM2Moyen > 0
                    ? `${Math.round(stats.prixM2Moyen / 1000)}k`
                    : '-'}
                </div>
                <div className="stat-label">DZD/m²</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">
                  {Math.round(stats.prixMin / 1000000)}M
                </div>
                <div className="stat-label">{t.tools.minPrice}</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">
                  {Math.round(stats.prixMax / 1000000)}M
                </div>
                <div className="stat-label">{t.tools.maxPrice}</div>
              </div>
            </div>
            <div className="stat-card" style={{marginBottom: '1.2rem'}}>
              <div className="stat-value" style={{fontSize: '0.85rem'}}>
                {formatPrix(stats.prixMoyen)}
              </div>
              <div className="stat-label">{t.tools.avgPrice}</div>
            </div>
          </>
        )}

        {/* POIs par categorie */}
        <div className="panel-section-title">{t.carte.amenities}</div>
        <div className="pois-section">
          {Object.entries(pois).map(([type, items]) => {
            const config = POI_ICONS[type] || { icon: '📍', color: '#999' };
            const label = t.carte.poi[type] || type;
            return (
              <div className="poi-category" key={type}>
                <div className="poi-category-header">
                  <span className="poi-category-icon">{config.icon}</span>
                  {label} ({items.length})
                </div>
                <ul className="poi-list">
                  {items.map(poi => (
                    <li className="poi-item" key={poi.id}>
                      {poi.nom}
                      {poi.sous_type && (
                        <span className="poi-sous-type">{poi.sous_type}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Types disponibles */}
        {stats.typesDisponibles && stats.typesDisponibles.length > 0 && (
          <>
            <div className="panel-section-title">{t.carte.propertyTypes}</div>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginBottom: '1rem'}}>
              {stats.typesDisponibles.map(t => (
                <span key={t} style={{
                  background: 'var(--bg-input)',
                  padding: '0.2rem 0.6rem',
                  borderRadius: '12px',
                  fontSize: '0.75rem',
                  color: 'var(--text)'
                }}>{t}</span>
              ))}
            </div>
          </>
        )}

        {/* Actions */}
        <div className="panel-actions">
          <Link
            to={`/?quartier=${quartier.nom}`}
            className="btn btn-primary"
          >
            {t.carte.seeListings(quartier.nom)}
          </Link>
          <Link
            to={`/outils/estimateur`}
            className="btn btn-secondary"
          >
            {t.carte.estimateBtn}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default QuartierPanel;
